module.exports = __webpack_public_path__ + "img/raincloud-grey.7a1477f0.svg";